<template>
  <div class="editor-chart-panel" v-loading="loading">
    <div class="filter-list" v-show="fieldExpand">
      <div class="add-btn-content">
        <el-button type="primary" class="add-btn" @click="researchFieldsModalShow = true" v-if="!handleDisabled">
          <span>课题全部标签</span>
        </el-button>
      </div>
      <div class="filter-ul">
        <div class="filter-li" v-for="item in fieldColumnTypeArr" :key="item.type">
          <h3>{{ item.label }}</h3>
          <div class="dimension-list">
            <draggable
              class="left-field-ul"
              :value="item.list"
              :options="{
                group: { name: 'tableGroup' },
                handle: '.drag-title',
                forceFallback: true,
                chosenClass: 'chosen-class',
                dragClass: 'drag-class',
                fallbackTolerance: 10
              }"
              @start="event => dragHandle({ draging: true, event, columns: item.list })"
              @end="event => dragHandle({ draging: false, event, columns: item.list })"
              :move="moveHandle"
            >
              <div
                v-for="(fieldItem, fieldIndex) in item.list"
                :key="`${fieldItem.columnKey}_${fieldIndex}`"
                class="dimension-list-item"
                :class="fieldPickEnum[fieldItem.columnKey] ? 'is-pick' : ''"
              >
                <i class="el-icon-loading field-iconfont" v-if="fieldRuning[fieldItem.columnKey]"></i>
                <img v-else class="field-img" :src="fetchFieldIcon(fieldItem).img" alt="" />
                <div
                  class="text-content single-ellipsis"
                  :class="fieldRuning[fieldItem.columnKey] ? '' : 'drag-title'"
                  @click.stop="tapFieldHandle(fieldItem)"
                >
                  <span>{{ fieldItem.title }}</span>
                </div>
                <i
                  v-if="!fieldItem.isDefaultStatistic"
                  class="iconfont iconshanchu del-icon field-iconfont"
                  @click.stop="delColumnHandle(fieldItem)"
                ></i>
              </div>
            </draggable>
          </div>
        </div>
      </div>

      <i class="el-icon-arrow-left expand-icon" @click="fieldExpand = false"></i>
    </div>
    <i class="el-icon-arrow-right filter-list-expand-icon" @click="fieldExpand = true" v-show="!fieldExpand"></i>

    <div class="research-content">
      <div class="filter-content">
        <filter-pane
          :courseConditionArr="JSON.parse(courseDetail._source.condition || '[]')"
          :instrumentType="courseDetail._source.instrumentType"
        >
          <filter-tips
            :courseId="courseDetail._id"
            :instrumentType="courseDetail._source.instrumentType"
            :courseConditionArr="JSON.parse(courseDetail._source.condition || '[]')"
            :sortInfoCustom="researchModel.sortInfoCustom"
            :courseFilterArr="courseFilterArr"
            :courseSortInfo="courseDetail._source.sortInfo"
            :researchFilterArr="conditionFilterArr"
            :researchSortInfo="researchModel.sortInfo"
            @updFilter="
              filterItem => EventBus.$emit('originDataAction', { func: 'showFilterHandle', params: { filterItem } })
            "
            @delFilter="
              params => EventBus.$emit('originDataAction', { func: 'delFieldFilterHandle', params: params.index })
            "
            @delSort="params => EventBus.$emit('originDataAction', { func: 'delSortHandle', params })"
            @delSortCustom="() => EventBus.$emit('originDataAction', { func: 'delSortCustomHandle' })"
          >
            <template slot="head-content">
              <el-tooltip effect="dark" placement="bottom">
                <div slot="content">
                  <div>为本图表添加数据筛选条件，</div>
                  <div>此筛选条件会与课题数据集的</div>
                  <div>筛选条件叠加</div>
                </div>
                <div class="header-add-btn" @click="EventBus.$emit('originDataAction', { func: 'showFilterHandle' })">
                  <i class="el-icon-plus add-icon"></i>
                  <span>添加筛选</span>
                </div>
              </el-tooltip>
            </template>
          </filter-tips>
        </filter-pane>
      </div>
      <div class="filter-res">
        <div class="row-column">
          <template v-if="isTableAnalysisChart">
            <div class="row-column-item" :class="effDragContent.includes('column-field') ? 'could-drag' : ''">
              <span class="field-ul">
                <i class="iconfont iconyinbianliang"></i>
                <span>因变量</span>
              </span>
              <span class="field-tip-text" v-if="!draging && columns.length < 1">拖拽左侧标签到因变量进行数据分析</span>
              <draggable
                v-model="columns"
                group="tableGroup"
                class="tag-ul column-field field-group"
                :move="moveHandle"
                @start="draging = true"
                @end="draging = false"
                @add="e => addFieldSuccessHandle(e, columns, { isTableAnalysisChart: true })"
              >
                <div class="tag-item" v-for="(ele, index) in columns" :key="`${ele.columnKey}_${index}`">
                  <div class="data-dimension" :style="{ backgroundColor: fetchFieldIcon(ele).color }">
                    <span>{{ ele.title }}</span>
                    <i class="el-icon-close footer-icon" @click="removeDimension('column', index)"></i>
                  </div>
                </div>
              </draggable>
            </div>
            <div class="row-column-item" :class="effDragContent.includes('row-field') ? 'could-drag' : ''">
              <span class="field-ul">
                <i class="iconfont iconzibianliang"></i>
                <span>自变量</span>
              </span>
              <span class="field-tip-text" v-if="!draging && rows.length < 1">拖拽左侧标签到自变量进行数据分析</span>
              <draggable
                v-model="rows"
                group="tableGroup"
                class="tag-ul row-field field-group"
                :move="moveHandle"
                @start="draging = true"
                @end="draging = false"
                @add="e => addFieldSuccessHandle(e, rows, { isTableAnalysisChart: true })"
              >
                <div class="tag-item" v-for="(ele, index) in rows" :key="`${ele.columnKey}_${index}`">
                  <div class="data-dimension" :style="{ backgroundColor: fetchFieldIcon(ele).color }">
                    <span>{{ ele.title }}</span>
                    <i class="el-icon-close footer-icon" @click="removeDimension('row', index)"></i>
                  </div>
                </div>
              </draggable>
            </div>
          </template>
          <template v-else>
            <div class="row-column-item" :class="effDragContent.includes('normal-field') ? 'could-drag' : ''">
              <span class="field-ul">
                <i class="iconfont iconhang"></i>
                <span>统计标签</span>
              </span>
              <span class="field-tip-text" v-if="!draging && statisticFieldArr.length < 1"
                >点击或拖拽左侧标签进来进行数据分析</span
              >
              <draggable
                v-model="statisticFieldArr"
                group="tableGroup"
                class="tag-ul normal-field field-group"
                :move="moveHandle"
                @start="draging = true"
                @end="draging = false"
                @add="e => addFieldSuccessHandle(e, statisticFieldArr)"
              >
                <div
                  class="tag-item"
                  v-for="(ele, index) in statisticFieldArr"
                  :key="`${ele.mode}_${ele.info.fieldDetail.columnKey}`"
                >
                  <el-popover
                    placement="bottom-start"
                    trigger="click"
                    :ref="`field_${index}`"
                    @show="fieldExpandIndex = index"
                    @after-leave="fieldExpandIndex === index ? (fieldExpandIndex = -1) : ''"
                  >
                    <div
                      slot="reference"
                      class="data-dimension"
                      :style="{ backgroundColor: fetchFieldIcon(ele.info.fieldDetail).color }"
                    >
                      <span>{{ ele.info.fieldDetail.title }}</span>
                      <span v-html="transformFieldTipMsg(ele)"></span>
                      <i class="el-icon-caret-bottom footer-icon"></i>
                    </div>
                    <div>
                      <statisticFieldPopover
                        v-if="fieldExpandIndex === index"
                        :ref="`field_filter_${index}`"
                        :detail="ele"
                        :modeDisabled="ele | modeDisabledFilter(statisticFieldArr)"
                      />
                      <div class="tag-filter-bottom">
                        <el-button size="mini" @click="removeDimension('field', index)">移除</el-button>
                        <el-button size="mini" type="primary" @click="changeFilterHandle({ index })">
                          <span>确 认</span>
                        </el-button>
                      </div>
                    </div>
                  </el-popover>
                </div>
              </draggable>
            </div>
            <div class="row-column-item">
              <span class="field-ul">
                <i class="iconfont icontongjidanwei"></i>
                <span>统计单位</span>
              </span>
              <div class="tag-ul">
                <el-select
                  :style="{ margin: '3px 10px', width: '140px' }"
                  size="mini"
                  v-model="relationFilterVal"
                  @change="(statisticsTab.series = null), setCondition(refreshWatcher)"
                >
                  <el-option
                    v-for="relationItem in courseUnitGroups"
                    :key="relationItem.id"
                    :value="relationItem.id"
                    :label="relationItem.name"
                  />
                </el-select>
              </div>
            </div>
          </template>
        </div>

        <div class="chart-preview">
          <div class="chart-preview-title">
            <div class="title-text" @click="titleEditor.init(researchModel.title)">
              <span>{{ researchModel.title }}</span>
              <span class="field-x-tip">X轴标签默认显示10个</span>
              <i class="iconfont iconbianji edit-icon"></i>
            </div>
            <div class="chart-preview-tools">
              <template v-if="!handleDisabled">
                <span class="chart-type-btn" @click="$emit('copy')">
                  <i class="iconfont iconfuzhi download-icon"></i>
                  <span>复制研究点</span>
                </span>
                <span class="chart-type-btn" @click="downloadShow = true">
                  <i class="iconfont iconxiazai download-icon"></i>
                  <span>下载</span>
                </span>
              </template>
            </div>
          </div>
          <div class="chart-body">
            <div class="chart-body-panel">
              <grid-layout :is-draggable="false" :layout.sync="chartLayoutInfo" :col-num="12" :row-height="160">
                <grid-item
                  :style="{ overflow: 'auto' }"
                  :x="chartLayoutInfo[0].x"
                  :y="chartLayoutInfo[0].y"
                  :w="chartLayoutInfo[0].w"
                  :h="chartLayoutInfo[0].h"
                  :i="chartLayoutInfo[0].i"
                  :min-w="12"
                  :max-w="12"
                  @resized="resizeChartHandle()"
                  @container-resized="resizeChartHandle()"
                >
                  <component
                    :ref="researchModel.type"
                    :is="researchModel.type"
                    :rows="rows"
                    :statistics="statistics"
                    @chartTap="chartTapHandle"
                  ></component>
                </grid-item>
              </grid-layout>
              <div class="total-surplus-tips" v-if="false" v-show="fieldSizeTipsShow">
                <span>图表标签数默认显示10个，如需更多，在右侧栏的“</span>
                <span>{{ researchModel.type === 'barXChart' ? 'Y' : 'X' }}</span>
                <span>轴标签数设置”进行设置。</span>
              </div>
            </div>
          </div>
        </div>

        <div class="origin-data-content" :class="fullscreen ? 'is-fullscreen' : ''">
          <div class="tab-header-tools">
            <el-button size="mini" class="blue-btn" @click="dataCleanHandle" v-if="!handleDisabled">
              <i class="iconfont iconshuju"></i>
              <span>数据清洗</span>
            </el-button>
            <el-dropdown @command="type => exportHandle(type)" :disabled="exportLoading">
              <el-button type="text" class="export-btn" :loading="exportLoading">
                <span v-show="exportLoading">导出中...</span>
                <span v-show="!exportLoading">
                  <img :src="exportImg" />
                  <span>导出excel</span>
                </span>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="table" v-if="!isTableAnalysisChart">
                  <span>导出统计表格</span>
                </el-dropdown-item>
                <el-dropdown-item v-for="typeItem in metadataTypes" :key="typeItem.value" :command="typeItem.value">
                  <span>{{ typeItem.subLabel || typeItem.label }}</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <i
              class="iconfont fullscreen-btn"
              :class="fullscreen ? 'iconsuofang' : 'iconquanping'"
              @click="fullscreen = !fullscreen"
            ></i>
          </div>
          <el-tabs v-model="defaultTabVal" @tab-remove="statisticsTab.series = null">
            <el-tab-pane label="统计数据" name="table" :disabled="isTableAnalysisChart">
              <table-chart
                ref="statisticTableRef"
                v-if="!isTableAnalysisChart"
                showSort
                :rows="rows"
                :statistics="statistics"
                :sortStatistic="sortStatistic"
                @sortHandle="statisticSortHandle"
              />
            </el-tab-pane>
            <el-tab-pane label="元数据" name="origin">
              <slot name="originData"></slot>
            </el-tab-pane>
            <el-tab-pane :label="statisticsTab.tabName" name="series" closable v-if="statisticsTab.series">
              <series-statistics-tab
                ref="seriesStatisticsRef"
                :instrumentType="courseDetail._source.instrumentType"
                :series="statisticsTab.series"
                :rows="statisticsTab.rows"
                :columns="statisticsTab.columns"
                :statistics="statisticsTab.statistics"
                :relationFilterVal="statisticsTab.relationFilterVal"
              />
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>

    <chart-config-editor
      v-if="!isTableAnalysisChart"
      ref="chartConfigEditor"
      :show="showChartConfig"
      :rows="rows"
      :columns="columns"
      :statistics="statistics"
      :chart-detail="researchModel"
      :defaultChartConfig="defaultChartConfig"
      @initApis="apis => (chartConfigApis = apis)"
      @changeChartConfigHandle="changeChartConfigHandle"
      @changeFieldSizeHandle="changeFieldSizeHandle"
      @showChartConfig="showChartConfig = !showChartConfig"
    />

    <fieldsEditor
      v-if="researchFieldsModalShow"
      :show.sync="researchFieldsModalShow"
      :courseDetail="courseDetail"
      :researchModel="researchModel"
      @success="updResearchFields"
    />

    <chart-download
      v-if="downloadShow"
      :show.sync="downloadShow"
      :courseDetail="courseDetail"
      :researchModel="researchModel"
    />

    <el-dialog
      title="修改统计图表名称"
      :visible.sync="titleEditor.show"
      width="520px"
      :before-close="() => (titleEditor.show = false)"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form @submit.native.prevent>
        <el-form-item label="统计图表名称">
          <el-input placeholder="请输入统计图表名称" :maxlength="100" v-model="titleEditor.title" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="titleEditor.show = false">取 消</el-button>
        <el-button type="primary" @click="updTitleHandle()">
          <span>确 定</span>
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Draggable from 'vuedraggable';
import { GridLayout, GridItem } from 'vue-grid-layout';
import pieChart from '@/components/chartComponents/pieChart';
import pieChart2 from '@/components/chartComponents/pieChart2';
import barChart from '@/components/chartComponents/barChart';
import barXChart from '@/components/chartComponents/barXChart';
import lineChart from '@/components/chartComponents/lineChart';
import lineChart2 from '@/components/chartComponents/lineChart2';
import numChart from '@/components/chartComponents/numChart';
import tableChart from '@/components/chartComponents/tableChart';
import tableAnalysisChart from '@/components/chartComponents/tableAnalysisChart';
import statisticFieldPopover from './statisticFieldPopover';
import chartDownload from '@/components/chartDownload';
import emptyTip from './emptyTip';
import filterPane from './filterPane';
import filterTips from '@/components/filterTips';
import SeriesStatisticsTab from './seriesStatisticsTab';
import fieldsEditor from '@/components/fieldsEditor';

import chartConfigEditor from './chartConfig';
import {
  checkChartInfo,
  exportExcel,
  formatDataSourceHandle,
  groupByFieldFilter,
  transformFieldToAnalysisMsg,
  fetchFieldIcon
} from '@/lib/utils';
import { selectStatistics, metadataTypes } from '@/constant';
import EventBus from '@/lib/eventBus';
import { services } from '@/service';
import exportImg from '@/assets/img/导出primary.png';
import Xlsx from 'xlsx';
import { computed } from 'vue';

const maxRowCount = 10;

export default {
  data() {
    return {
      exportImg,
      draging: false,
      fieldExpand: true,
      chartLayoutInfo: [{ x: 0, y: 0, w: 12, h: 2, i: '0' }],
      isDragging: false,
      rows: [],
      columns: [],
      statisticFieldArr: [],
      fieldExpandIndex: -1,
      statisticExpandIndex: -1,
      watcherInited: false,
      dataSet: null,
      defaultChartConfig: {},
      sortStatistic: null,
      loading: false,
      showChartConfig: true,
      statistics: [],
      titleEditor: {
        show: false,
        title: '',
        init: function(title) {
          this.show = true;
          this.title = title;
        }
      },
      downloadShow: false,
      shareDataShow: false,
      fullscreen: false,
      defaultTabVal: 'table',
      chartConfigApis: null,
      EventBus,
      statisticsTab: {
        series: null,
        rows: [],
        columns: [],
        statistics: [],
        tabName: '',
        relationFilterVal: ''
      },
      typeArr: [],
      effDragContent: [],
      relationFilterVal: '',
      timeoutController: 0,
      fieldRuning: {},
      researchFieldsModalShow: false,
      exportLoading: false,
      metadataTypes
    };
  },
  provide() {
    return {
      curUnitGroup: computed(() => this.curUnitGroup)
    };
  },
  inject: {
    courseUnitGroups: { default: () => [] }
  },
  components: {
    Draggable,
    chartConfigEditor,
    pieChart,
    pieChart2,
    barChart,
    barXChart,
    lineChart,
    lineChart2,
    numChart,
    tableChart,
    tableAnalysisChart,
    statisticFieldPopover,
    GridLayout,
    GridItem,
    chartDownload,
    emptyTip,
    filterPane,
    filterTips,
    SeriesStatisticsTab,
    fieldsEditor
  },
  props: {
    chartIndexId: {
      type: Number,
      required: true
    },
    courseDetail: {
      type: Object,
      required: true
    },
    researchModel: {
      type: Object,
      required: true
    },
    handleDisabled: {
      type: Boolean,
      default: false
    }
  },
  filters: {
    formatFieldType(fieldItem, typeArr) {
      const arr = typeArr[`${fieldItem.type}_entity`];
      let fullTypeName = fieldItem.type;
      if (fieldItem.deputy_type) {
        fullTypeName = `${fullTypeName}_${fieldItem.deputy_type}`;
      }
      if (!arr) {
        return '';
      }
      const detail = arr.find(item => item.type === fullTypeName);
      return (detail && detail.label) || '-';
    },
    modeDisabledFilter(item, statisticFieldArr) {
      const { columnKey } = item.info.fieldDetail;
      let count = 0;
      statisticFieldArr.forEach(statisticFieldItem => {
        if (statisticFieldItem.info.fieldDetail.columnKey === columnKey) {
          count++;
        }
      });
      return count > 1;
    }
  },
  computed: {
    refreshWatcher() {
      return { rows: this.rows, columns: this.columns, statistics: this.statistics };
    },
    isTableAnalysisChart() {
      return this.researchModel.type === 'tableAnalysisChart';
    },
    fieldPickEnum() {
      const pickEnum = {};
      const arr = [...this.statistics, ...this.rows, ...this.columns];
      const statisticsCount = this.statistics.length;
      arr.forEach((item, index) => {
        let fieldDetail = item;
        if (index < statisticsCount) {
          fieldDetail = item.fieldDetail;
        }
        pickEnum[fieldDetail.columnKey] = true;
      });
      return pickEnum;
    },
    fieldsColumns() {
      return this.researchModel.fields;
    },
    fieldColumnTypeArr() {
      return groupByFieldFilter(this.fieldsColumns).filter(group => group.list.length > 0);
    },
    courseFilterArr() {
      return JSON.parse(this.courseDetail._source.conditionTemp || '[]');
    },
    conditionFilterArr() {
      return JSON.parse(this.researchModel.conditionTemp || '[]');
    },
    fieldSizeTipsShow() {
      return this.rows.every(rowItem => {
        return !rowItem.size || rowItem.size === 10;
      });
    },
    curUnitGroup() {
      return this.courseUnitGroups.find(o => o.id === this.relationFilterVal);
    }
  },

  watch: {
    'statisticsTab.series'(val) {
      if (!val) {
        this.defaultTabVal = 'origin';
      }
    },
    refreshWatcher: {
      handler(val) {
        if (this.watcherInited) {
          this.setCondition(val);
        }
      }
    },
    statisticFieldArr: {
      handler(val) {
        const needFormat = val.some(item => !item.mode || !item.info);
        if (!needFormat) {
          const rows = [];
          const statistics = [];

          val.forEach(item => {
            const isRowMode = item.mode === 'rowMode';
            if (isRowMode) {
              rows.push(item.info.fieldDetail);
            } else {
              statistics.push(item.info);
            }
          });

          this.rows = rows;
          this.statistics = statistics;
          this.statisticsTab.series = null;
          return;
        }

        let formatIndex = -1;
        const fieldCountEnum = {};
        let haveRowMode = false;
        val.forEach((item, index) => {
          if (item.mode && item.info) {
            fieldCountEnum[item.info.fieldDetail.columnKey] = item.mode;
            if (item.mode === 'rowMode') {
              haveRowMode = true;
            }
          } else {
            formatIndex = index;
          }
        });
        const item = val[formatIndex];
        let mode = '';
        if (haveRowMode) {
          if (!fieldCountEnum[item.columnKey] || fieldCountEnum[item.columnKey] === 'rowMode') {
            mode = 'statisticMode';
          } else {
            mode = 'rowMode';
          }
        } else {
          if (fieldCountEnum[item.columnKey] === 'rowMode') {
            mode = 'statisticMode';
          } else {
            mode = 'rowMode';
          }
        }
        let data = null;
        const isRowMode = mode === 'rowMode';
        if (isRowMode) {
          data = { mode, info: { fieldDetail: item } };
        } else {
          data = { mode, info: { ...selectStatistics[0], fieldDetail: item, isStatistic: true } };
        }
        this.statisticFieldArr.splice(formatIndex, 1, data);
      }
    }
  },

  beforeDestroy() {
    this.clearTimeoutController();
  },

  async mounted() {
    this.typeArr = await services.labelRelation.getEntityRelation();

    this.relationFilterVal = this.researchModel.relationFilterVal;
    if (!this.curUnitGroup) {
      this.relationFilterVal = this.courseUnitGroups[0].id;
    }

    if (this.isTableAnalysisChart) {
      const rows = this.researchModel.rows || [];
      const columns = this.researchModel.columns || [];
      this.defaultTabVal = 'origin';
      this.rows = rows;
      this.columns = columns;
    } else {
      this.statisticFieldArr = this.researchModel.statisticFieldArr || [];
    }

    /**
     * 此处nextTick控制refreshWatcher不执行图表生成操作
     * 由下面逻辑判断需要接口生成还是由旧数据渲染
     */
    await this.$nextTick();
    this.watcherInited = true;

    const dataSet = JSON.parse(this.researchModel.dataSet || '{}');
    this.sortStatistic = JSON.parse(this.researchModel.sortStatistic || '{}');

    const shouldInit =
      this.courseDetail._source.refresh ||
      this.relationFilterVal !== this.researchModel.relationFilterVal ||
      Object.keys(dataSet).length < 1;

    if (shouldInit) {
      this.setCondition(this.refreshWatcher);
    } else {
      this.dataSet = dataSet;
      EventBus.$emit('getCaseList');
      this.refreshChartAndTable();
    }
    this.fetchTaskHandle();
    this.$emit('initApis', {
      setCondition: () => this.setCondition(this.refreshWatcher),
      updTitle: title => this.titleEditor.init(title)
    });
  },

  methods: {
    fetchFieldIcon,
    clearTimeoutController() {
      if (this.timeoutController) {
        clearTimeout(this.timeoutController);
      }
      this.timeoutController = 0;
    },
    async fetchTaskHandle() {
      try {
        const keys = this.fieldsColumns.map(item => item.columnKey);
        const result = await services.caseRule.getTaskQueueInfo(this.courseDetail._id, keys);
        const pending = result.data
          .map(taskItem => {
            if (['running', 'pending'].includes(taskItem._source.status)) {
              return taskItem._source.field_name;
            }
            return '';
          })
          .filter(fieldName => !!fieldName);
        this.clearTimeoutController();
        if (pending.length > 0) {
          this.timeoutController = setTimeout(() => this.fetchTaskHandle(), 2000);
        }
        const fieldRuning = {};
        pending.forEach(columnKey => {
          fieldRuning[columnKey] = true;
        });
        this.fieldRuning = fieldRuning;
      } catch (err) {
        this.clearTimeoutController();
        this.$error(err);
      }
    },
    transformFieldTipMsg(item) {
      return transformFieldToAnalysisMsg({
        mode: item.mode,
        fieldDetail: item.info.fieldDetail,
        dataStr: item.info.fieldDetail ? item.info.fieldDetail.valueOfFilter : '',
        relationFilterName: this.curUnitGroup.name
      });
    },
    showFieldSizeHandle() {
      this.$refs.chartConfigEditor.showCollapse('fieldSize');
    },
    chartTapHandle(series) {
      const { rows, columns, statistics } = this.refreshWatcher;
      let tabName = series.seriesName;
      if (
        series.seriesType === 'pie' ||
        (rows.length === 1 && statistics.length <= 1) ||
        (rows.length === 0 && statistics.length > 1)
      ) {
        tabName = series.name;
      }
      this.statisticsTab = {
        series,
        rows: [...rows],
        columns: [...columns],
        statistics: [...statistics],
        relationFilterVal: this.relationFilterVal,
        tabName
      };
      if (this.$refs.seriesStatisticsRef) {
        this.$refs.seriesStatisticsRef.refreshHandle();
      }
      this.$nextTick(() => {
        this.defaultTabVal = 'series';
      });
    },
    closePopoverHandle(type, index) {
      const el = this.$refs[`${type}_${index}`];
      el && el[0] && el[0].doClose();
    },
    async changeFilterHandle(options) {
      try {
        const { index } = options;
        this.closePopoverHandle('field', index);
        const data = this.$refs[`field_filter_${index}`][0].validateInfo();
        this.statisticFieldArr.splice(index, 1, data);
      } catch (err) {
        this.$message.error(err.message);
      }
    },
    removeDimension(type, index) {
      if (type === 'row') {
        this.rows.splice(index, 1);
      }
      if (type === 'column') {
        this.columns.splice(index, 1);
      }
      if (type === 'field') {
        this.closePopoverHandle(type, index);
        this.statisticFieldArr.splice(index, 1);
      }
    },
    async statisticSortHandle(sortInfo) {
      this.sortStatistic = sortInfo;
      await this.refreshChartAndTable();
      this.$emit('changeChartDetail', {
        chartIndexId: this.chartIndexId,
        detail: {
          ...this.researchModel,
          sortStatistic: JSON.stringify(this.sortStatistic)
        }
      });
    },
    async setCondition({ rows, columns, statistics }) {
      try {
        this.loading = true;

        let checkType = '';
        if (this.chartConfigApis) {
          // 等待chartConfig内的computed根据新的行列通计算计算完毕
          await this.$nextTick();
          const effChartArr = this.chartConfigApis.fetchEffChartArr();
          if (!effChartArr.includes(this.researchModel.type)) {
            checkType = effChartArr[0];
          }
        }

        this.dataSet = null;
        this.sortStatistic = {};
        if (checkType) {
          this.$emit('changeChartDetail', {
            chartIndexId: this.chartIndexId,
            detail: {
              ...this.researchModel,
              rows,
              columns,
              statistics,
              sortStatistic: JSON.stringify(this.sortStatistic),
              relationFilterVal: this.relationFilterVal,
              relationFilterName: this.curUnitGroup.name,
              statisticFieldArr: this.statisticFieldArr
            },
            saveChart: false
          });
          this.chartConfigApis.changeTypeHandle(checkType);
        } else {
          await this.refreshChartAndTable();
          this.$emit('changeChartDetail', {
            chartIndexId: this.chartIndexId,
            detail: {
              ...this.researchModel,
              rows,
              columns,
              statistics,
              sortStatistic: JSON.stringify(this.sortStatistic),
              relationFilterVal: this.relationFilterVal,
              relationFilterName: this.curUnitGroup.name,
              statisticFieldArr: this.statisticFieldArr,
              dataSet: JSON.stringify(this.dataSet)
            }
          });
        }

        this.$nextTick(() => {
          EventBus.$emit('getCaseList');
        });
      } catch (err) {
        this.$error(err);
      } finally {
        this.loading = false;
      }
    },
    updTitleHandle() {
      const title = this.titleEditor.title;
      if (!title) {
        this.$message.warning('请输入研究点标题');
        return;
      }
      this.titleEditor.show = false;
      this.$emit('changeChartDetail', {
        chartIndexId: this.chartIndexId,
        detail: { ...this.researchModel, title }
      });
    },
    async resizeChartHandle() {
      // 等待grid-layout重排完再执行echart渲染
      await this.$nextTick();
      const el = this.$refs[this.researchModel.type];
      if (el) {
        el.resize();
      }
    },
    changeFieldSizeHandle({ rowSizeArr, columnSizeArr }) {
      rowSizeArr.forEach((size, index) => {
        this.rows[index].size = size;
      });
      columnSizeArr.forEach((size, index) => {
        this.columns[index].size = size;
      });
      this.setCondition(this.refreshWatcher);
    },
    async refreshChartAndTable(refreshOptions) {
      const { isChangeTheme = false } = refreshOptions || {};
      const el = this.$refs[this.researchModel.type];
      const statisticTableEl = this.$refs.statisticTableRef;

      const options = { haveOriginData: !!this.dataSet };
      const componData = checkChartInfo({
        colors: this.researchModel.colors,
        chartConfig: this.researchModel.chartConfig,
        rows: this.rows,
        columns: this.columns,
        statistics: this.statistics,
        researchCondition: this.researchModel.conditionTemp,
        courseCondition: this.courseDetail._source.conditionTemp,
        courseId: this.courseDetail._id,
        sortStatistic: this.sortStatistic,
        relationFilterVal: this.relationFilterVal,
        relationFilterName: this.curUnitGroup.name
      });

      if (options.haveOriginData) {
        componData.originData = this.dataSet;
      }

      let result = {};

      if (isChangeTheme) {
        result = await el.changeThemeHandle({ ...componData }, options);
      } else {
        result = await el.refresh({ ...componData }, options);
      }

      const { dataSet = {}, defaultChartConfig = {} } = result;

      if (statisticTableEl) {
        statisticTableEl.refresh({ ...componData, originData: dataSet }, { haveOriginData: true });
      }

      if (this.$refs.seriesStatisticsRef) {
        this.$refs.seriesStatisticsRef.refreshHandle();
      }

      if (!options.haveOriginData) {
        this.dataSet = dataSet;
      }

      this.defaultChartConfig = defaultChartConfig;
    },
    async changeChartConfigHandle(params) {
      const { type, chartConfigStr, colors } = params;

      const isChangeTheme = JSON.stringify(colors) !== JSON.stringify(this.researchModel.colors);
      const chartConfig = JSON.parse(chartConfigStr);

      let saveChart = true;
      if (!this.dataSet) {
        saveChart = false;
      }

      this.$emit('changeChartDetail', {
        chartIndexId: this.chartIndexId,
        detail: { ...this.researchModel, type, chartConfig, colors },
        saveChart
      });

      await this.$nextTick();

      await this.refreshChartAndTable({ isChangeTheme });

      if (!saveChart) {
        this.$emit('changeChartDetail', {
          chartIndexId: this.chartIndexId,
          detail: {
            ...this.researchModel,
            dataSet: JSON.stringify(this.dataSet)
          }
        });
      }
    },
    fetchFieldIndex(data) {
      const arr = [...this.rows, ...this.columns];
      const index = arr.findIndex(item => item.columnKey === data.columnKey);
      return index;
    },
    fetchStatisticFieldCount(data) {
      let count = 0;
      this.statisticFieldArr.forEach(item => {
        if (item.info.fieldDetail.columnKey === data.columnKey) {
          count++;
        }
      });
      return count;
    },
    addStatisticFieldLog(fieldItem) {
      if (fieldItem && fieldItem.system) {
        const info = [`${fieldItem.columnKey}-${fieldItem.full_name}`];
        services.logger.handleLog({ operateName: '添加系统预置维度', otherParams: { info } });
      }
    },
    tapFieldHandle(fieldItem) {
      if (this.fieldRuning[fieldItem.columnKey]) {
        return;
      }

      // 高级模型
      if (this.isTableAnalysisChart) {
        if (fieldItem.type === 'date' || this.fetchFieldIndex(fieldItem) > -1) {
          return;
        }
        if (this.columns.length === 0) {
          this.columns.push(fieldItem);
        } else if (this.rows.length < 10) {
          this.rows.push(fieldItem);
        }
      } else {
        const count = this.fetchStatisticFieldCount(fieldItem);
        count < 2 && this.statisticFieldArr.push(fieldItem);
      }
      this.addStatisticFieldLog(fieldItem);
    },
    addFieldSuccessHandle({ newIndex }, arr, options = {}) {
      const { isTableAnalysisChart = false } = options;
      if (isTableAnalysisChart) {
        this.addStatisticFieldLog(arr[newIndex]);
      } else {
        this.addStatisticFieldLog(arr[newIndex].info.fieldDetail);
      }
    },
    dragHandle({ draging, event, columns }) {
      const { oldDraggableIndex } = event;
      const fieldItem = columns[oldDraggableIndex];

      this.effDragContent = [];
      this.draging = draging;
      if (!draging) {
        return;
      }

      if (this.isTableAnalysisChart) {
        if (fieldItem.type === 'date' || this.fetchFieldIndex(fieldItem) > -1) {
          return;
        }
        if (this.columns.length < 1) {
          this.effDragContent.push('column-field');
        }
        if (this.rows.length < maxRowCount) {
          this.effDragContent.push('row-field');
        }
      } else {
        const count = this.fetchStatisticFieldCount(fieldItem);
        count < 2 && this.effDragContent.push('normal-field');
      }
    },
    moveHandle(event) {
      const fromClassName = event.from.className;
      const toClassName = event.to.className;

      if (
        fromClassName.includes('left-field-ul') &&
        toClassName.includes('left-field-ul') &&
        fromClassName !== toClassName
      ) {
        return false;
      }

      if (this.isTableAnalysisChart) {
        if (fromClassName.includes('field-group')) {
          return fromClassName === toClassName;
        }
        const toColumnField = toClassName.includes('column-field');
        const toRowField = toClassName.includes('row-field');
        if (toColumnField) {
          return this.effDragContent.includes('column-field');
        }
        if (toRowField) {
          return this.effDragContent.includes('row-field');
        }
      } else {
        if (fromClassName.includes('field-group') && toClassName.includes('field-group')) {
          return true;
        }
        return this.effDragContent.includes('normal-field');
      }
      return true;
    },
    dataCleanHandle() {
      this.$router.push({
        path: '/data-cleaner',
        query: {
          courseware_id: this.$route.query.courseware_id,
          index_id: this.$route.query.index_id
        }
      });
    },
    async delColumnHandle(columnItem) {
      await this.$confirm(`是否移除标签【${columnItem.title}】?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      });
      const fields = this.fieldsColumns.filter(fieldItem => fieldItem.columnKey !== columnItem.columnKey);
      this.$emit('changeChartDetail', {
        refreshData: true,
        chartIndexId: this.chartIndexId,
        detail: { ...this.researchModel, fields }
      });
    },
    updResearchFields(detail) {
      this.$emit('refreshCourseDetail', detail);
      this.researchFieldsModalShow = false;
      this.$nextTick(() => {
        this.setCondition(this.refreshWatcher);
        this.fetchTaskHandle();
      });
    },
    async exportHandle(downloadType) {
      if (this.exportLoading) {
        return;
      }
      this.exportLoading = true;
      try {
        if (downloadType === 'table') {
          await this.exportTableHandle();
          this.$message.success('导出成功');
        } else {
          const conditionTemp = JSON.parse(this.researchModel.conditionTemp || '[]');
          const query = formatDataSourceHandle({ query: conditionTemp }).query;
          const fields = this.fieldsColumns.map(item => {
            return { field_name: item.field_name, chinese_name: item.title };
          });
          const params = {
            courseware_id: this.courseDetail._id,
            title: this.researchModel.title,
            query,
            fields,
            downloadType,
            parentId: this.relationFilterVal
          };
          const result = await services.courseware.downMetadata2(params);
          const reader = new FileReader();
          reader.readAsDataURL(result);
          reader.onload = e => {
            const a = document.createElement('a');
            a.download = `${this.courseDetail._source.title}.xlsx`;
            a.href = e.target.result;
            a.click();
            this.$message.success('导出成功');
          };
        }
      } catch (err) {
        this.$error(err);
      } finally {
        this.exportLoading = false;
      }
    },
    exportTableHandle() {
      const { headData, rowData } = this.$refs.statisticTableRef.tableInfo;
      if (rowData.length < 1) {
        throw new Error('当前暂无数据导出');
      }
      const sheetHeader = headData.map(item => item.val);
      const excelData = [sheetHeader];
      rowData.forEach(item => {
        const newRowData = sheetHeader.map(key => item[key] || '');
        excelData.push(newRowData);
      });
      exportExcel(Xlsx.utils.aoa_to_sheet(excelData), `${this.researchModel.title}统计数据.xlsx`);
    }
  }
};
</script>
<style lang="scss" scoped>
$box-shadow: 0 2px 4px 2px rgba(#8196b4, 0.16);
$fontSize: 14px;

.popover-tip-content {
  width: 200px;
  padding: 10px;

  .popover-tip-li {
    color: rgba(#2c3443, 0.8);
    font-size: 12px;
    line-height: 22px;
  }
}

.field-popover-content {
  padding: 12px;
  .field-popover-title {
    color: #2c3443;
    font-size: 14px;
    margin-bottom: 10px;
  }

  .field-popover-field-ul {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-wrap: wrap;
    margin-top: 10px;

    .tip-title {
      width: 100%;
      font-size: 12px;
      color: #2c3443;
      margin-bottom: 5px;
    }

    .field-item {
      padding: 0 5px;
      color: #fff;
      border-radius: 2px;
      margin-right: 5px;
      margin-bottom: 5px;

      &:last-child {
        margin-right: 0;
      }
    }
  }
}

.tag-filter-bottom {
  box-sizing: border-box;
  position: relative;
  width: 100%;
  border-top: 1px solid #d9dde4;
  padding: 12px;
  text-align: right;
}

.editor-chart-panel {
  position: relative;
  height: 100%;
  display: flex;
  justify-content: space-between;
  background-color: #f9fbff;

  .filter-list-expand-icon {
    position: absolute;
    top: 35px;
    left: 4px;
    font-size: 12px;
    cursor: pointer;
    padding: 4px;
    box-shadow: 0px 0px 6px 2px rgb(48 57 69 / 20%);
    border-radius: 50%;
    background-color: #fff;
    z-index: 10;

    &:hover {
      color: #fff;
      background-color: rgba(#1991fb, 0.8);
    }
  }

  .filter-list {
    position: relative;
    width: 240px;
    height: 100%;
    background: #fff;
    border-right: 1px solid #d9dde4;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    &:hover {
      .expand-icon {
        opacity: 1;
      }
    }

    .add-btn-content {
      color: #1991fb;
      padding: 15px 20px 5px;

      .add-btn {
        width: 100%;
        font-size: 14px;
        .add-icon {
          margin-right: 4px;
          font-weight: bold;
        }
      }
    }

    .filter-ul {
      width: 100%;
      flex: 1;
      height: 0;
      box-sizing: border-box;
      overflow-x: hidden;
      overflow-y: auto;
      padding-top: 20px;

      .filter-li {
        margin-top: 20px;

        &:first-child {
          margin-top: 0;
        }
      }
    }

    .expand-icon {
      position: absolute;
      top: 35px;
      right: -14px;
      font-size: 12px;
      cursor: pointer;
      padding: 4px;
      box-shadow: 0px 0px 6px 2px rgb(48 57 69 / 20%);
      border-radius: 50%;
      background-color: #fff;
      opacity: 0;
      z-index: 10;

      &:hover {
        color: #fff;
        background-color: rgba(#1991fb, 0.8);
      }
    }

    h3 {
      color: #3d465a;
      font-size: $fontSize;
      font-weight: bold;
      margin: 0 20px;
    }
    .dimension-list {
      margin-top: 10px;
    }
  }

  .research-content {
    flex: 1;
    width: 0;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;

    .filter-content {
      box-sizing: border-box;
      min-height: 40px;
      background-color: #fff;
      border-bottom: 1px solid #e8ebef;

      .header-add-btn {
        box-sizing: border-box;
        display: inline-block;
        height: 24px;
        line-height: 22px;
        font-size: 12px;
        color: #1991fb;
        background-color: #eaf6ff;
        border-radius: 4px;
        padding: 0 10px;
        cursor: pointer;
        border: 1px solid #d9ecff;
        margin-right: 10px;
        margin-bottom: 10px;
        vertical-align: middle;

        .add-icon {
          margin-right: 5px;
        }
      }
    }

    .filter-res {
      box-sizing: border-box;
      width: 100%;
      padding: 0 10px;
      .row-column {
        margin-top: 10px;
        background: #ffffff;
        box-shadow: $box-shadow;
        border-radius: 2px;
        color: rgba(#001529, 0.8);
        font-size: $fontSize;
        .row-column-item {
          box-sizing: border-box;
          display: flex;
          align-items: flex-start;
          padding: 2px 20px;
          line-height: 30px;
          cursor: pointer;
          border-bottom: 1px solid #e8ebef;

          &.could-drag {
            outline: 1px dashed #409eff;
          }

          &:last-child {
            border-bottom: 0;
          }

          .field-tip-text {
            color: #d9dde4;
            margin-left: 10px;
          }

          .field-popover {
            display: flex;
            margin-left: 10px;
            .iconfont {
              font-size: 16px;
              color: #409eff;
              background-color: #ecf5ff;
              padding: 0 6px;
              border-radius: 4px;
            }
          }

          .field-ul {
            font-size: 12px;
            color: rgba(#001529, 0.7);
            .iconfont {
              position: relative;
              font-size: 16px;
              top: 2px;
              left: -4px;
            }
          }

          .tag-ul {
            position: relative;
            flex: 1;
            width: 0;
            display: flex;
            align-items: flex-start;
            flex-wrap: wrap;
            min-height: 30px;

            .field-tip-text {
              position: absolute;
              top: 50%;
              left: 0;
              transform: translateY(-50%);
              color: rgba(#000, 0.4);
            }
            .tag-item {
              margin-left: 10px;
              margin-top: 6px;
              margin-bottom: 6px;
            }
          }

          .expand-icon {
            margin-left: 5px;
          }
        }
      }

      .data-dimension {
        padding: 0 10px;
        line-height: 24px;
        color: #fff;
        font-size: 12px;
        height: 24px;
        border-radius: 4px;
        display: flex;

        &.orange {
          background-color: #ffa938;
        }

        .footer-icon {
          position: relative;
          top: 4px;
          font-size: 14px;
          padding: 1px 3px;
          padding-right: 0;
        }
      }

      .origin-data-content {
        position: relative;
        background: #ffffff;
        box-shadow: $box-shadow;
        border-radius: 2px;
        margin-top: 10px;

        &.is-fullscreen {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 100;
          overflow: auto;
          border-radius: 0;
          box-shadow: none;
          margin-top: 0;
        }

        ::v-deep .el-tabs {
          .el-tabs__header {
            margin: 0;
          }

          .el-tabs__nav-wrap {
            &::after {
              height: 1px;
            }
          }

          .el-tabs__nav-scroll {
            box-sizing: border-box;
            padding: 5px 20px 0;
          }
        }

        .data-pagition {
          font-size: 14px;
          color: rgba(#2c3443, 0.8);
          line-height: 20px;
          padding: 14px 20px 12px;

          .iconbangzhu {
            font-size: 14px;
            color: rgba(#2c3443, 0.6);
            margin-right: 4px;
          }
        }

        .tab-header-tools {
          display: flex;
          align-items: center;
          position: absolute;
          top: 8px;
          right: 20px;
          z-index: 99;

          .export-btn {
            margin-left: 0;
            margin-right: 10px;
            padding: 0;

            img {
              position: relative;
              top: 2px;
              width: 14px;
              margin-right: 4px;
            }
          }

          .blue-btn {
            color: #1991fb;
            border: 1px solid #1991fb;
            margin-right: 10px;

            .iconfont {
              font-size: 12px;
              margin-right: 3px;
            }

            &:last-child {
              margin-right: 0;
            }
          }
          .fullscreen-btn {
            cursor: pointer;
            font-size: 20px;
            color: #1991fb;
            margin-right: 8px;

            &:last-child {
              margin-right: 0;
            }
          }
        }
      }

      .chart-preview {
        background: #ffffff;
        box-shadow: $box-shadow;
        border-radius: 2px;
        margin-top: 10px;
        &-title {
          line-height: 40px;
          padding: 0 20px;
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          border-bottom: 1px solid #e8ebef;

          .chart-preview-tools {
          }

          .title-text {
            flex: 1;
            width: 0;
            font-size: $fontSize;
            line-height: 20px;
            color: #2c3443;
            cursor: pointer;
            padding: 10px 0;

            .edit-icon {
              display: none;
              margin-left: 5px;
            }

            .field-x-tip {
              margin-left: 5px;
              font-size: 12px;
              color: #9599a5;
            }

            &:hover {
              .edit-icon {
                display: inline;
              }
              .field-x-tip {
                display: none;
              }
            }
          }
          .chart-type-btn {
            cursor: pointer;
            color: #3d465a;
            font-size: 12px;
            padding: 2px 10px;
            padding-right: 0;
            margin-left: 10px;

            .chart-type-btn-img {
              position: relative;
              top: 2px;
              height: 14px;
              margin-right: 5px;
            }

            .iconfont {
              color: #1991fb;
              margin-right: 4px;
              font-size: 14px;
            }
          }
        }
        .chart-body {
          width: 100%;

          .chart-body-panel {
            width: 100%;

            .total-surplus-tips {
              width: 100%;
              height: 20px;
              line-height: 20px;
              text-align: center;
              font-size: 12px;
              color: rgba(#2c3443, 0.5);
              padding-bottom: 10px;
            }
          }
        }
      }
    }
  }

  .statistic-list {
    position: relative;
    margin: 0 20px;
    padding-top: 30px;
    &::after {
      content: '';
      display: inline-block;
      top: 10px;
      left: 0;
      background: #e8ebef;
      width: 100%;
      height: 1px;
      position: absolute;
    }
    h4 {
      color: #3d465a;
      margin-bottom: 20px;
      font-size: $fontSize;
    }
    &-item {
      font-size: $fontSize;
      color: #2c3443;
      line-height: 18px;
    }
  }
}

.chosen-class {
  .dimension-list-item {
    box-sizing: border-box;
    margin-top: 6px;
    height: 20px;
    background: #eaf6ff !important;
    padding: 0 10px !important;
    .iconfont {
      display: none;
    }
  }
}

.drag-class {
  .dimension-list-item {
    background: #eaf6ff !important;
    padding: 0 10px !important;
    .iconfont {
      display: none;
    }
  }
}

.dimension-list-item {
  position: relative;
  box-sizing: border-box;
  width: 219px;
  font-size: $fontSize;
  color: #2c3443;
  display: flex;
  align-items: center;
  padding: 0 30px 0 10px;
  margin: 0 10px;
  line-height: 26px;
  cursor: pointer;
  margin-bottom: 2px;

  .text-content {
    flex: 1;
    width: 0;
  }
  .field-icon {
    height: 14px;
    margin-right: 4px;
  }

  .del-icon {
    position: absolute;
    right: 0px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 14px;
    color: rgba(#2c3443, 0.5);
    padding: 2px 5px;
    opacity: 0;
  }

  .field-iconfont {
    font-size: 16px;
    margin-right: 4px;
  }

  .field-img {
    width: 16px;
    margin-right: 4px;
  }

  &.is-pick {
    background-color: #eaf6ff;
  }

  &:hover {
    background-color: #eaf6ff;
    .del-icon {
      opacity: 1;
    }
  }
}
</style>
